<template>
  <div>
    <Button type="primary" @click="modal1 = true">新增</Button>

    <Table :columns="columns10" :data="data9"> </Table>

    <Modal
      v-model="modal1"
      title="新增版本"
      width="1000"
      :loading="loading"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <div>
        <Form :label-width="120">
          <FormItem label="版本号">
            <Input placeholder="请输入版本号" v-model="version"></Input>
          </FormItem>
          <FormItem label="是否强更">
            <Checkbox v-model="isupdate">是</Checkbox>
          </FormItem>
          <FormItem label="类型">
            <RadioGroup v-model="ntype">
              <Radio label="0">iOS</Radio>
              <Radio label="1">android</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="版本说明">
            <Input placeholder="请输入版本说明" v-model="message"></Input>
          </FormItem>
          <FormItem label="更新地址">
            <Input placeholder="请输入更新地址" v-model="upurl"></Input>
          </FormItem>
          <FormItem label="是否审核">
            <Checkbox v-model="isshenhe">是</Checkbox>
          </FormItem>
          <FormItem label="备注">
            <Input placeholder="请输备注" v-model="remark"></Input>
          </FormItem>
        </Form>
      </div>
    </Modal>
  </div>
</template>
<script>
import SingleUpload from "@/components/Upload/singleUpload";
import { cmsVersionList, addVersion, updateVersion } from "../../api/version";

const OSS = require("ali-oss");
var ossClient = null;
export default {
  components: { SingleUpload },
  data() {
    return {
      modal3: false,
      searchDate: [],
      version: "",
      isupdate: "0",
      ntype: "0",
      message: "",
      upurl: "",
      isshenhe: "0",
      remark: "",
      loading: true,
      modal1: false,
      xbid: "", //小板id
      xbsort: 1, //小板座位号
      clickmachineid: "",
      videourl1: "",
      videourl2: "",
      columns10: [
        {
          title: "版本号",
          key: "version",
        },
        {
          title: "是否强更",
          key: "isupdate",
        },
        {
          title: "类型",
          key: "ntype",
          render: (h, params) => {
            var machinetype = params.row.ntype == "0" ? "iOS" : "android";
            return h("span", machinetype);
          },
        },
        {
          title: "更新信息",
          key: "message",
        },

        {
          title: "更新链接",
          key: "upurl",
        },

        {
          title: "是否审核中",
          key: "isshenhe",

          render: (h, params) => {
            return h("div", [
              h("i-switch", {
                props: {
                  type: "primary",
                  value: params.row.isshenhe == 1 ? true : false, // 判断是否选中
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  "on-change": (isChecked) => {
                    console.log("change", isChecked);
                    this.updateVersion(params.row.version, isChecked ? 1 : 0);
                  },
                },
              }),
            ]);
          },
        },
        {
          title: "备注",
          key: "remark",
        },
      ],
      data9: [],
    };
  },
  mounted() {
    this.selmachine();
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    selmachine() {
      cmsVersionList({}).then((res) => {
        console.log("===" + JSON.stringify(res));

        this.data9 = res.data;
      });
    },
    updateVersion(id, isshenhe) {
      updateVersion({ version: id, isshenhe: isshenhe }).then((res) => {
        this.selmachine();
      });
    },

    ok() {
      console.log(
        this.version,
        this.isupdate,
        this.ntype,
        this.message,
        this.upurl,
        this.isshenhe,
        this.remark
      );
      addVersion({
        version: this.version,
        isupdate: this.isupdate == "true" ? 1 : 0,
        ntype: this.ntype,
        message: this.message,
        upurl: this.upurl,
        isshenhe: this.isshenhe == "true" ? 1 : 0,
        remark: this.remark,
      }).then((res) => {
        this.selmachine();
      });
    },
    cancel() {
      this.$Message.info("Clicked cancel");
    },
    updateMachineStatus(status) {
      updateMachineStatus({ status: status, roomid: this.clickmachineid }).then(
        (res) => {
          this.selmachine();
        }
      );
    },
    guanbimodal() {
      this.modal3 = false;
    },
  },
};
</script>
